import Backbone from 'backbone';
const $ = Backbone.$;

module.exports = Backbone.View.extend({
  tagName: 'div',
  template() {
    const iconClose = `${this.conf.domain}img/icon_close.png`;
    return `<div id="widget-greeting" class="widgetGreeting mf" style="bottom: 85px; right: 26px; position: absolute;">
            <div class="icon_close"><img style="width: 18px; height:18px" src="${iconClose}" ></div>
            ${this.conf.widget_setting.popup_message}</div> 
        `;
  },
  initialize(o) {
    const model = this.model;
    model.view = this;
    this.conf = o.config || {};
    this.pfx = this.conf.stylePrefix || '';
  },

  render() {
    const { $el, model, conf } = this;
    const that = this;
    const pos =
      conf.chat_box_position === 7 || conf.chat_box_position === 4
        ? 'left'
        : 'right';
    this.display = true;
    $el.attr({ class: `${this.pfx}widget_greeting` });
    $el.html(this.template());

    this.closeIcon = $el.find('.icon_close');
    this.content = $el
      .find('.widgetGreeting')
      .css({ opacity: 0, display: 'none' });
    if (pos === 'left') {
      this.content.css({ right: 'auto', left: '26px' });
      this.closeIcon.css({ left: 'auto', right: '-10px' });
    }
    this.content.on('click', function(e) {
      if (that.display) {
        that.display = false;
        model.trigger('onContentClick');
      }
    });
    // setting color
    setTimeout(() => {
      this.content.css('background-color', conf.widget_setting.bg_popup_color);
      this.closeIcon.css(
        'background-color',
        conf.widget_setting.bg_icon_close_color
      );
      const fontSize = parseInt(conf.widget_setting.font_size);
      this.content.css('color', conf.widget_setting.txt_popup_color);
      this.content.css('font-size', `${fontSize}px`);
      this.content.css('line-height', `${fontSize + 6}px`);
    }, 50);

    this.closeIcon.on('click', function(e) {
      e.stopPropagation();
      model.trigger('handleCloseGreeting');
    });

    return this;
  }
});
